import React, { useState } from "react";
import PageHeader from "../../components/PageHeader";
import PageActions from "../../components/PageActions";
import Table from "../../components/Table";
import Modal from "../../components/Modal";
import FilterModal from "../../components/FilterModal";
import Pagination from "../../components/Pagination";
import { createTableActions } from "../../utils/tableActions";
import CardapioForm from "./components/CardapioForm";
import { cardapioFilterFields } from "./constants/filterFields";
import { CardapioProvider, useCardapio } from "./context/CardapioContext";

const CardapioContent: React.FC = () => {
  const {
    sabores,
    isLoading,
    isModalOpen,
    formState,
    isSaving,
    tableData,
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    filters,
    filterErrors,
    handleFieldChange,
    handleSearch,
    handleClear,
    clearFilterErrors,
    setCurrentPage,
    openCreateModal,
    openEditModal,
    closeModal,
    handleDelete,
    handleSubmit,
    setFormNome,
    setFormIngredientes,
    setFormTipo,
    setFormFoto,
    removerFotoAtual,
  } = useCardapio();

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const activeFiltersCount = Object.values(filters).filter(
    (value) => value !== null && value !== undefined && value !== ""
  ).length;

  const filterFields = cardapioFilterFields.map((field) => ({
    ...field,
    value: filters[field.name as keyof typeof filters] || "",
  }));

  const tableActions = createTableActions(
    (rowIndex) => {
      const selectedSabor = sabores[rowIndex];
      if (!selectedSabor) return;
      openEditModal(selectedSabor);
    },
    (rowIndex) => {
      const selectedSabor = sabores[rowIndex];
      if (!selectedSabor) return;
      handleDelete(selectedSabor);
    }
  );

  return (
    <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <div className="mb-4 mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <PageHeader
          title="Cardápio"
          description="Cadastre sabores com lista dinâmica de ingredientes."
        />
        <PageActions
          onFilter={() => setIsFilterModalOpen(true)}
          onAdd={openCreateModal}
          addButtonText="Novo Sabor"
          activeFiltersCount={activeFiltersCount}
        />
      </div>

      <hr />

      <div className="overflow-x-auto pb-4">
        <div className="min-w-max">
          <Table
            headers={["Foto", "Sabor", "Tipo", "Ingredientes"]}
            data={tableData}
            actions={tableActions}
          />
        </div>
      </div>

      {totalPages > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={setCurrentPage}
        />
      )}

      {isLoading && (
        <div className="mt-3 text-sm text-neutral-500">
          Carregando sabores...
        </div>
      )}

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => {
          clearFilterErrors();
          setIsFilterModalOpen(false);
        }}
        fields={filterFields}
        errors={filterErrors}
        onFieldChange={handleFieldChange}
        onSearch={() => {
          if (handleSearch()) setIsFilterModalOpen(false);
        }}
        onClear={handleClear}
        gridClassName="grid grid-cols-2 gap-4"
      />

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title={formState.id ? "Editar Sabor" : "Novo Sabor"}
      >
        {isModalOpen && (
          <CardapioForm
            nome={formState.nome}
            ingredientes={formState.ingredientes}
            tipo={formState.tipo}
            fotoUrl={
              formState.fotoUrl
                ? `${process.env.REACT_APP_API_URL || "http://localhost:3001"}${formState.fotoUrl}`
                : null
            }
            isSaving={isSaving}
            onSubmit={handleSubmit}
            onCancel={closeModal}
            onNomeChange={setFormNome}
            onIngredientesChange={setFormIngredientes}
            onTipoChange={setFormTipo}
            onFotoChange={setFormFoto}
            onRemoverFoto={removerFotoAtual}
          />
        )}
      </Modal>
    </main>
  );
};

const Cardapio: React.FC = () => {
  return (
    <CardapioProvider>
      <CardapioContent />
    </CardapioProvider>
  );
};

export default Cardapio;
